import { useTheme } from '@orrekie/ui';

import { useEffect } from 'react';

/**
 * Free/basic users cannot toggle theme — keep shell on light tokens so sidebar and
 * page copy stay readable regardless of prior localStorage or OS colour preference.
 */
export function useEnforceLightThemeForFreeAudience(isFreeAudience: boolean): void {
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    if (isFreeAudience && theme !== 'light') {
      setTheme('light');
    }
  }, [isFreeAudience, theme, setTheme]);
}
